import one from "../../assets/images/type-index/1.png";
import three from "../../assets/images/type-index/3.png";
import five from "../../assets/images/type-index/5.png";
import six from "../../assets/images/type-index/6.png";
import seven from "../../assets/images/type-index/7.png";
import eight from "../../assets/images/type-index/8.png";
import nine from "../../assets/images/type-index/9.png";
import ten from "../../assets/images/type-index/10.png";
import eleven from "../../assets/images/type-index/11.png";
import twelve from "../../assets/images/type-index/12.png";

export const familyTypes = [
  {
    id: 1,
    cellClassName: "typeGridCell",
    feature: "type1",
    label: "פטריות כובע בעלות דפים",
    avatar: one,
    structures: {
      1: {
        name: "עם טבעת ונרתיק",
        sizes: {
          1: {
            name: "גדולות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אמנית",
                    path: "type/amanita",
                  },
                ],
              },
            },
          },
        },
      },
      2: {
        name: "עם טבעת בלבד",
        sizes: {
          1: {
            name: "גדולות ובינוניות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "גידמית הדורה",
                    path: "type/gymnopilus",
                  },
                  {
                    name: "סידית",
                    path: "type/limacella",
                  },
                  {
                    name: "נירנית",
                    path: "type/agrocybe",
                  },
                  {
                    name: "ירוקת דפים",
                    path: "type/chlorophyllum",
                  },
                  {
                    name: "מוצקה",
                    path: "type/mutzaka",
                  },
                  {
                    name: "מטרנית",
                    path: "type/macrolepiota",
                  },
                  {
                    name: "פקועה",
                    path: "type/agaricus",
                  },
                  {
                    name: "לבקנית",
                    path: "type/leucoagaricus",
                  },
                ],
              },
              2: {
                name: "על גזע או ענף",
                types: [
                  {
                    name: "נירנית הצפצפה",
                    path: "type/niranit-hatzaftzefa",
                  },
                ],
              },
            },
          },
          2: {
            name: "קטנות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אבנטית",
                    description:
                      " – הדפים בגוון מצהבהב ועד סגול-חום. הכפה כהה במרכז.",
                    path: "type/avnatit",
                  },
                  {
                    name: "מטריינית",
                    description:
                      " – הדפים בגוון לבן עד קרם. הכפה בגווני צהוב, אחיד.",
                    path: "type/lepiota",
                  },
                ],
              },
              2: {
                name: "בעציצים וחממות",
                types: [
                  {
                    name: "עציצית",
                    path: "type/leucocoprinus",
                  },
                  {
                    name: "ליבנית",
                    path: "type/leucocoprinus",
                  },
                ],
              },
            },
          },
        },
      },
      3: {
        name: "עם נרתיק בלבד",
        sizes: {
          1: {
            name: "גדולות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אמנית מקושטת",
                    description:
                      " - המין מקושטת - הכפה בגוון חום-צהבהב ועליה ניכרים שאריות צעיף ,שולי הכובע מחורצים או מפוספסים.",
                    path: "type/amanita",
                  },
                  {
                    name: "אמנית הנרתיק",
                    description:
                      " - המין נרתיק -  דומה למקושטת, נבדלת בצבע כפה אפרפר.",
                    path: "type/amanita",
                  },
                  {
                    name: "נרתיקנית",
                    description:
                      " – המין חורש – גדלה על גזעי עץ.  המין נאה דביקה - גדלה בעשבייה על הקרקע.",
                    path: "type/volvariella",
                  },
                ],
              },
            },
          },
          2: {
            name: "קטנות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "נרתיקנית קטנה",
                    path: "type/nartikanit-ktana",
                  },
                ],
              },
            },
          },
        },
      },
      4: {
        name: "ללא טבעת ונרתיק",
        sizes: {
          1: {
            name: "גדולות ובינוניות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אחלמית",
                    path: "type/lepista",
                  },
                  {
                    name: "דפונית",
                    path: "type/lyophyllum",
                  },
                  {
                    name: "חריפית",
                    path: "type/russula",
                  },
                  {
                    name: "ישעורית",
                    path: "type/tricholoma",
                  },
                  {
                    name: "לחלחה",
                    path: "type/hygrophorus",
                  },
                  {
                    name: "נטופה",
                    path: "type/lactarius",
                  },
                  {
                    name: "ציצנית",
                    path: "type/hebeloma",
                  },
                  {
                    name: "קשקשנית",
                    path: "type/pholiota",
                  },
                  {
                    name: "שחרחרית",
                    path: "type/melanoleuca",
                  },
                  {
                    name: "הינומה",
                    path: "type/cortinarius",
                  },
                  {
                    name: "שעירית",
                    path: "type/tricholomella",
                  },
                ],
              },
              2: {
                name: "על גזע או ענף",
                types: [
                  {
                    name: "גידמית חודרנית",
                    description: " - המין חודרנית – גדלה על ענפים או גזעים.",
                    path: "type/gymnopilus",
                  },
                  {
                    name: "להבית",
                    description:
                      " - כפה  כתומה, חלקה ומבריקה, הדפים לבנים, גדלה בקבוצות.",
                    path: "type/lehavit",
                  },
                  {
                    name: "קטיפנית",
                    description: " – הכפה אינה חלקה, המירקם קטיפתי.",
                    path: "type/pluteus",
                  },
                  {
                    name: "גחונית",
                    description:
                      " - צבע כפה ערמוני, 'צווארון' בחלק עליון של הרגל. נדירה.",
                    path: "type/hypholoma",
                  },
                ],
              },
            },
          },
          2: {
            name: "קטנות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אדומית",
                    path: "type/entoloma",
                  },
                  {
                    name: "אסימונית",
                    path: "type/collybia",
                  },
                  {
                    name: "אפורית",
                    path: "type/tephrocybe",
                  },
                  {
                    name: "דפופית",
                    path: "type/dafufit",
                  },
                  {
                    name: "לחית",
                    path: "type/hygrocybe",
                  },
                  {
                    name: "סיבית",
                    path: "type/inocybe",
                  },
                  {
                    name: "שברירית",
                    path: "type/psathyrella",
                  },
                  {
                    name: "קטיפנית",
                    path: "type/pluteus",
                  },
                  {
                    name: "שרפית",
                    path: "type/laccaria",
                  },
                  {
                    name: "נבובית",
                    path: "type/macrocystidia",
                  },
                ],
              },
              2: {
                name: "על גזע, איצטרובל או ענף",
                types: [
                  {
                    name: "פיטרה",
                    path: "type/pitra",
                  },
                  {
                    name: "צמדית",
                    path: "type/hymenopellis",
                  },
                ],
              },
            },
          },
          3: {
            name: "זעירות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "כומתית",
                    path: "type/galerina",
                  },
                  {
                    name: "סוככית",
                    path: "type/tubaria",
                  },
                  {
                    name: "צנומה",
                    path: "type/marasmius",
                  },
                ],
              },
              2: {
                name: "על גזע, ענף או עלה",
                types: [
                  {
                    name: "זיפנית",
                    path: "type/crinipellis",
                  },
                  {
                    name: "צנומית",
                    path: "type/marasmiellus",
                  },
                ],
              },
            },
          },
        },
      },
      5: {
        name: "דפים גולשים על הרגל",
        sizes: {
          1: {
            name: "בינוני",
            platforms: {
              1: {
                name: "על קרקע גזע או ענף",
                types: [
                  {
                    name: "גולשנית",
                    path: "type/golshanit",
                  },
                  {
                    name: "גמישנית",
                    path: "type/lentinus",
                  },
                  {
                    name: "משפכנית",
                    path: "type/clitocybe ",
                  },
                  {
                    name: "קמרונית",
                    path: "type/chroogomphus",
                  },
                  {
                    name: "קמרונית",
                    path: "type/gomphidius",
                  },
                ],
              },
            },
          },
        },
      },
      6: {
        name: "דפים גולשים ללא רגל",
        sizes: {
          1: {
            name: "גודל בינוני",
            platforms: {
              1: {
                name: "על קרקע גזע או ענף",
                types: [
                  {
                    name: "גביעונית",
                    path: "type/cantharellus",
                  },
                  {
                    name: "מרזבית",
                    path: "type/hoenbuelia",
                  },
                ],
              },
            },
          },
        },
      },
      7: {
        name: "חסרות רגל או רגל קצרצרה",
        sizes: {
          1: {
            name: "גדולות",
            platforms: {
              1: {
                name: "על קרקע, גזע או ענף",
                types: [
                  {
                    name: "אזנית",
                    path: "type/pleurotus",
                  },
                ],
              },
            },
          },
          2: {
            name: "קטנות",
            platforms: {
              1: {
                name: "על גזע או ענף",
                types: [
                  {
                    name: "אפרכסית",
                    path: "type/panus",
                  },
                  {
                    name: "אפרקדנית",
                    path: "type/resupinatus",
                  },
                  {
                    name: "דרדסית",
                    path: "type/crepidotus",
                  },
                  {
                    name: "שסועית",
                    path: "type/schizophyllum",
                  },
                  {
                    name: "שרועית",
                    path: "type/tapinella",
                  },
                ],
              },
              2: {
                name: "בין טחבים",
                types: [],
              },
            },
          },
        },
      },
      8: {
        name: "כובע חרוטי (לא בזיקנה)",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "דיואית",
                    path: "type/coprinus",
                  },
                  {
                    name: "חרוטית",
                    path: "type/conocybe",
                  },
                  {
                    name: "שברירית",
                    path: "type/psathyrella",
                  },
                  {
                    name: "צבעונית",
                    path: "type/panaeolus",
                  },
                ],
              },
              2: {
                name: "על גללי בע''ח",
                types: [
                  {
                    name: "גללית",
                    path: "type/bolbitius",
                  },
                  {
                    name: "קרוחה",
                    path: "type/deconica",
                  },
                  {
                    name: "צבעונית",
                    path: "type/panaeolus",
                  },
                ],
              },
            },
          },
        },
      },
      9: {
        name: "כובע עם שקע",
        sizes: {
          1: {
            name: "גדול או קטן",
            platforms: {
              1: {
                name: "על גזע או על טחב",
                types: [
                  {
                    name: "טבורית",
                    description: " - גודל בינוני עד גדול, על גזע או בבסיסו.",
                    path: "type/omphalotus",
                  },
                  {
                    name: "ארהניה",
                    description: " - גודל קטן, גדלה על טחב או בסביבתו.",
                    path: "type/arrhenia",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 4,
    cellClassName: "typeGridCell",
    feature: "type4",
    label: "פטריות כובע בעלות ספוג",
    avatar: three,
    structures: {
      1: {
        name: "ספוג אדום, צהוב או בהיר",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אורנייה",
                    description:
                      " - צבעי כפה בגווני בז' וחום, עובי רגל בינוני, אינה מכחילה בחתך, הנקבים בספוג קטנים ועגולים.",
                    path: "type/suillus",
                  },
                  {
                    name: "גושית",
                    description:
                      " - צבעי כפה שונים, עובי רגל ובשר הכובע עבים, חלק מהמינים מכחילים בחתך.",
                    path: "type/boletus",
                  },
                  {
                    name: "לבדית",
                    description:
                      " - צבעי כפה בג' אפרפר או אדום, עובי רגל דק, הנקבים בספוג גדולים ומצולעים.",
                    path: "type/xerocomus",
                  },
                ],
              },
            },
          },
        },
      },
      2: {
        name: "ספוג בצבע אחר",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "גושית",
                    path: "type/boletus",
                  },
                  {
                    name: "גושנית",
                    path: "type/leccinum",
                  },
                  {
                    name: "חרירית",
                    path: "type/gyroporus",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 5,
    cellClassName: "typeGridCell",
    feature: "type5",
    label: "פטריות בעלות שיניים",
    avatar: six,
    structures: {
      1: {
        name: "עם רגל",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "שיננית",
                    description:
                      " - רגל קצרה יחסית, לצעירה צבע הכובע לבן, השיניים באורך עד 7 מ''מ.",
                    path: "type/hydnum",
                  },
                  {
                    name: "שינונית",
                    description:
                      " - רגל ארוכה יחסית, לצעירה צבע הכובע חום בהיר, השיניים באורך עד 5 מ''מ.",
                    path: "type/hydnellum",
                  },
                  {
                    name: "הדורית",
                    description: " - הצבע לבן, גדולה יחסית.",
                    path: "type/boletopsis",
                  },
                  {
                    name: "סרקודון",
                    description: " - הצבע חום בהיר או כהה, הגודל קטן יחסית.",
                    path: "type/sarcodon",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 6,
    cellClassName: "typeGridCell",
    feature: "type6",
    label: "פטריות בעלות נקבוביות",
    avatar: five,
    structures: {
      1: {
        name: "חסרות רגל",
        sizes: {
          1: {
            name: "גדולות",
            platforms: {
              1: {
                name: "על גזע או ענף",
                types: [
                  {
                    name: "נקובית",
                    path: "type/laetiporus",
                  },
                ],
              },
            },
          },
          2: {
            name: "קטנות",
            platforms: {
              1: {
                name: "על ענף דק בקרקע",
                types: [
                  {
                    name: "נקבובנית חרפית",
                    path: "type/nakvuvit-horfit",
                  },
                ],
              },
            },
          },
        },
      },
      2: {
        name: "עם רגל",
        sizes: {
          1: {
            name: "קטנות",
            platforms: {
              1: {
                name: "על ענף דק",
                types: [
                  {
                    name: "נקבובנית",
                    path: "type/polyporus",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 7,
    cellClassName: "typeGridCell",
    feature: "type7",
    label: "פטריות עציות-מדף על גזעים",
    avatar: seven,
    structures: {
      1: {
        name: "חסרות רגל",
        sizes: {
          1: {
            name: "גדולות",
            platforms: {
              1: {
                name: "על גזע",
                types: [
                  {
                    name: "אבוקית",
                    path: "type/fomes",
                  },
                  {
                    name: "בהוקית",
                    path: "type/ganoderma",
                  },
                  {
                    name: "מדפית",
                    path: "type/trametes",
                  },
                  {
                    name: "צמודית",
                    path: "type/fuscoporia",
                  },
                  {
                    name: "פתלתלית",
                    path: "type/ptaltalit",
                  },
                  {
                    name: "קשוטית",
                    path: "type/inonotus",
                  },
                  {
                    name: "עוגה",
                    path: "type/uga",
                  },
                ],
              },
            },
          },
          2: {
            name: "קטנות",
            platforms: {
              1: {
                name: "על גזע",
                types: [
                  {
                    name: "דפדפנית",
                    path: "type/gloeophyllum",
                  },
                  {
                    name: "מניפתית",
                    path: "type/thelephora",
                  },
                  {
                    name: "סוליינית",
                    path: "type/coriolopsis",
                  },
                  {
                    name: "קשיחית",
                    path: "type/stereum",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 8,
    cellClassName: "typeGridCell",
    feature: "type8",
    label: "פטריות בעלות 'ראש' מקומט או מחורר",
    avatar: ten,
    structures: {
      1: {
        name: "עם רגל",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "מרדעית",
                    path: "type/Leptopodia",
                  },
                ],
              },
            },
          },
        },
      },
      2: {
        name: "עם בסיס רחב מאורך",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "גמצוצית",
                    path: "type/gamtzutz-haruti",
                  },
                  {
                    name: "מרדעית",
                    path: "type/Leptopodia",
                  },
                ],
              },
            },
          },
        },
      },
      3: {
        name: "יוצאת מ'ביצה'",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "כישורית",
                    path: "type/colus",
                  },
                  {
                    name: "פינית",
                    path: "type/phallus",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 9,
    cellClassName: "typeGridCell",
    feature: "type9",
    label: "פטריות דמויות כוסית, קערית או כפלים",
    avatar: eight,
    structures: {
      1: {
        name: "דמויות כוסית, קערית או קפלים",
        sizes: {
          1: {
            name: "קטנות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "גביעית",
                    path: "type/helvella",
                  },
                  {
                    name: "זיפית",
                    path: "type/zifit",
                  },
                  {
                    name: "דיסקנית-קינמונית",
                    path: "type/discina-perlata",
                  },
                  {
                    name: "מצילה",
                    path: "type/cyathus",
                  },
                  {
                    name: "פזיזה",
                    path: "type/pziza",
                  },
                  {
                    name: "קופסית",
                    path: "type/geopyxis",
                  },
                  {
                    name: "קערית",
                    path: "type/sarcosphaera",
                  },
                  {
                    name: "שקועית",
                    path: "type/geopora",
                  },
                ],
              },
              2: {
                name: "על ענף",
                types: [
                  {
                    name: "אזנונית יהודה",
                    path: "type/auricularia",
                  },
                  {
                    name: "ספלונית",
                    path: "type/siflonit",
                  },
                ],
              },
            },
          },
          2: {
            name: "זעירות",
            platforms: {
              1: {
                name: "מצע לא רלוונטי",
                types: [
                  {
                    name: "ספלונית",
                    path: "type/siflonit",
                  },
                  {
                    name: "פנכית",
                    path: "type/barlaea",
                  },
                  {
                    name: "פכית",
                    path: "type/scutellinia",
                  },
                  {
                    name: "קערורית",
                    path: "type/marcelleina",
                  },
                  {
                    name: "שלהבת",
                    path: "type/pyronema",
                  },
                  {
                    name: "שפתנית",
                    path: "type/cheilymenia",
                  },
                ],
              },
              2: {
                name: "על קרקע, טחב או ענף",
                types: [
                  {
                    name: "מקלענית",
                    path: "type/sphaerobolus",
                  },
                  {
                    name: "תמנית",
                    path: "type/octospora",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 10,
    cellClassName: "typeGridCell",
    feature: "type10",
    label: "פטריות כדור או שקית",
    avatar: nine,
    structures: {
      1: {
        name: "כדור ללא בסיס",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "בתוך קרקע חולית",
                types: [
                  {
                    name: "כמהת חולות",
                    path: "type/terfesia",
                  },
                  {
                    name: "כמהית",
                    path: "type/kmehit",
                  },
                ],
              },
              2: {
                name: "בתוך רקבובית יער",
                types: [
                  {
                    name: "כמהת-יער",
                    path: "type/Tuber",
                  },
                  {
                    name: "פקעית",
                    path: "type/rizopogon",
                  },
                ],
              },
              3: {
                name: "על הקרקע",
                types: [
                  {
                    name: "דורנית",
                    path: "type/mycenastrum",
                  },
                  {
                    name: "פסיפסית",
                    path: "type/pisolithus",
                  },
                  {
                    name: "שחומית",
                    path: "type/melanogaster",
                  },
                  {
                    name: "כדורית",
                    path: "type/calvatia",
                  },
                  {
                    name: "כדורנית",
                    path: "type/bovista",
                  },
                  {
                    name: "פחוסית",
                    path: "type/disciseda",
                  },
                ],
              },
              4: {
                name: "על גזע או ענף",
                types: [
                  {
                    name: "קשתנית",
                    path: "type/daldinia",
                  },
                ],
              },
            },
          },
        },
      },
      2: {
        name: "עמוד ועליו שקית",
        sizes: {
          1: {
            name: "גדולות בינויות או קטנות",
            platforms: {
              1: {
                name: "על קרקע חולית",
                types: [
                  {
                    name: "כלונסית",
                    path: "type/battarrea",
                  },
                  {
                    name: "סדנית",
                    path: "type/podaix",
                  },
                  {
                    name: "עמודנית",
                    path: "type/schizostoma",
                  },
                  {
                    name: "פמוטית",
                    path: "type/phellorinia",
                  },
                  {
                    name: "פומית",
                    path: "type/tulostoma",
                  },
                ],
              },
            },
          },
        },
      },
      3: {
        name: "כדור עם בסיס",
        sizes: {
          1: {
            name: "גדולות בינויות או קטנות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אבקית",
                    path: "type/lycoperdon",
                  },
                  {
                    name: "עורית",
                    path: "type/scleroderma",
                  },
                  {
                    name: "פרגודית",
                    path: "type/vascellum",
                  },
                  {
                    name: "כרסנית",
                    path: "type/macowanites",
                  },
                ],
              },
            },
          },
        },
      },
      4: {
        name: "כדור בתוך כוכב/אונות",
        sizes: {
          1: {
            name: "גדולות בינויות או קטנות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אסתרית",
                    path: "type/esterit",
                  },
                  {
                    name: "כוכבנית",
                    path: "type/geastrum",
                  },
                  {
                    name: "רבפומית",
                    path: "type/myriostoma",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 11,
    cellClassName: "typeGridCell",
    feature: "type11",
    label: "פטריות קרומיות או קרישיות",
    avatar: twelve,
    structures: {
      1: {
        name: "שכבה שטוחה",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על ענף",
                types: [
                  {
                    name: "חודנית",
                    path: "type/chodanit",
                  },
                  {
                    name: "יפענית",
                    path: "type/terena",
                  },
                  {
                    name: "קרומית",
                    path: "type/krumit",
                  },
                  {
                    name: "שעמית",
                    path: "type/shaamit",
                  },
                ],
              },
            },
          },
        },
      },
      2: {
        name: "גושים או טיפות קריש",
        sizes: {
          1: {
            name: "גודל לא רלוונטי",
            platforms: {
              1: {
                name: "על ענף",
                types: [
                  {
                    name: "בצקת",
                    path: "type/batzeket",
                  },
                  {
                    name: "קרישית",
                    path: "type/tremella",
                  },
                  {
                    name: "רסיסית",
                    path: "type/dacrymyces",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
  {
    id: 12,
    cellClassName: "typeGridCell",
    feature: "type12",
    label: "פטריות דמויות אלמוג או אלה",
    avatar: eleven,
    structures: {
      1: {
        name: "דמויות אלמוג או אלה",
        sizes: {
          1: {
            name: "גדולות קטנות או בינוניות",
            platforms: {
              1: {
                name: "על הקרקע",
                types: [
                  {
                    name: "אלתית",
                    path: "type/clavaria",
                  },
                  {
                    name: "עציונית",
                    path: "type/xylaria",
                  },
                ],
              },
              2: {
                name: "על טחב",
                types: [
                  {
                    name: "לשונית",
                    path: "type/geoglossum",
                  },
                ],
              },
              3: {
                name: "על ענף",
                types: [
                  {
                    name: "קרנית",
                    path: "type/calocera",
                  },
                ],
              },
            },
          },
        },
      },
    },
  },
];

export const types = [
  { label: "אבוקית - Fomes", path: "fomes" },
  { label: "אבנטית - Stropharia", path: "stropharia" },
  { label: "אבקית - Lycoperdon", path: "lycoperdon" },
  { label: "אדומית - Entoloma", path: "entoloma" },
  { label: "אורנייה - Suillus", path: "suillus" },
  { label: "אזנונית יהודה - Auricularia", path: "auricularia" },
  { label: "אזנית - Pleurotus", path: "pleurotus" },
  { label: "אחלמית - Lepista", path: "lepista" },
  { label: "אלתית - Clavaria", path: "clavaria" },
  { label: "אלתית - Clavulina", path: "clavulina" },
  { label: "אלתית - Ramaria", path: "ramaria" },
  { label: "אמנית - Amanita", path: "amanita" },
  { label: "אסימונית - Collybia", path: "collybia" },
  { label: "אסתרית - Asteraeus", path: "asteraeus" },
  { label: "אפורית - Tephrocybe", path: "tephrocybe" },
  { label: "אפרקדנית - Resupinatus", path: "Resupinatus" },
  { label: "אפרכסית - Panus", path: "panus" },
  { label: "ארהניה - Arrhenia", path: "arrhenia" },
  { label: "בהוקית - Ganoderma", path: "ganoderma" },
  { label: "בקבוקנית - Pilobolus", path: "pilobolus" },
  { label: "גביעונית - Cantharellus", path: "cantharellus" },
  { label: "גביעית - Helvella", path: "helvella" },
  { label: "גולשנית - Rhodocybe", path: "rhodocybe" },
  { label: "גושית - Boletus", path: "boletus" },
  { label: "גושנית - Leccinum", path: "leccinum" },
  { label: "גחונית - Hypholoma", path: "hypholoma" },
  { label: "גידמית - Gymnopilus", path: "gymnopilus" },
  { label: "גללית - Bolbitius", path: "bolbitius" },
  { label: "גמישנית - Lentinus", path: "lentinus" },
  { label: "דורנית - Mycenastrum", path: "mycenastrum" },
  { label: "דיואית - Coprinus", path: "coprinus" },
  { label: "דיואית - Coprinellus", path: "coprinellus" },
  { label: "דיואית - Coprinopsis", path: "coprinopsis" },
  { label: "דיואית - Xerocoprinus", path: "xerocoprinus" },
  { label: "דיסקנית - Discina-Perlata", path: "discina" },
  { label: "דפדפנית - Gloeophyllum", path: "gloeophyllum" },
  { label: "דפונית - Lyophyllum", path: "lyophyllum" },
  { label: "דפופית - Montagnites", path: "montagnites" },
  { label: "דרדסית - Crepidotus", path: "crepidotus" },
  { label: "דרדסית - Symocibe", path: "symocibe" },
  { label: "הדורית - Boletopsis", path: "boletopsis" },
  { label: "הינומה - Cortinarius", path: "cortinarius" },
  { label: "היסטרית - Hystrerangium", path: "hystrerangium" },
  { label: "זיפנית - Crinipellis", path: "crinipellis" },
  { label: "חרוטית - Conocybe", path: "conocybe" },
  { label: "חריפית - Russula", path: "russula" },
  { label: "חרירית - Gyroporus", path: "gyroporus" },
  { label: "טבורית - Omphalotus", path: "omphalotus" },
  { label: "טורנדיה נאה - Torrendia", path: "torrendia" },
  { label: "יפענית - Terena", path: "terena" },
  {
    label: "ירוקת דפים קיצית – Molybdites-Chlorophyllum",
    path: "chlorophyllum",
  },
  { label: "ישעורית - Tricholoma", path: "tricholoma" },
  { label: "כדורנית - Bovista", path: "bovista" },
  { label: "כדורית - Bovista", path: "bovista" },
  { label: "כוכבנית - Geastrum", path: "geastrum" },
  { label: "כומתית - Galerina", path: "galerina" },
  { label: "כישורית - Colus", path: "colus" },
  { label: "כלונסית - Battarrea", path: "battarrea" },
  { label: "כמהת חולות - Terfesia", path: "terfesia" },
  { label: "כמהת יער - Tuber", path: "tuber" },
  { label: "כרסנית - Macowanites", path: "macowanites" },
  { label: "לבדית - Xerocomus", path: "xerocomus" },
  { label: "לבקנית - Leucoagaricus", path: "leucoagaricus" },
  { label: "להבית - Flammulina", path: "flammulina" },
  { label: "לחית - Hygrocybe", path: "hygrocybe" },
  { label: "לחלחה - Hygrophorus", path: "hygrophorus" },
  { label: "ליבנית - Leucocoprinus", path: "leucocoprinus" },
  { label: "לשונית - Geoglossum", path: "geoglossum" },
  { label: "מדפית - Trametes", path: "trametes" },
  { label: "מטריינית - Lepiota", path: "lepiota" },
  { label: "מטריינית - Chamaemyces", path: "chamaemyces" },
  { label: "מטרנית - Macrolepiota", path: "macrolepiota" },
  { label: "מניפתית - Thelephora", path: "thelephora" },
  { label: "מצילה - Cyathus", path: "cyathus" },
  { label: "מקלענית - Sphaerobolus", path: "sphaerobolus" },
  { label: "מרדעית - Leptopodia", path: "leptopodia" },
  { label: "מרזבית - Hoenbuelia", path: "hoenbuelia" },
  { label: "משפכנית - Clitocybe", path: "clitocybe" },
  { label: "נבובית - Macrocystidia", path: "macrocystidia" },
  { label: "נטופה - Lactarius", path: "lactarius" },
  { label: "נירנית - Agrocybe", path: "agrocybe" },
  { label: "נירנית - Cyclocybe", path: "cyclocybe" },
  { label: "נקבובנית - Polyporus", path: "polyporus" },
  { label: "נקבובנית - Cerioporus", path: "cerioporus" },
  { label: "נקובית - Laetiporus", path: "laetiporus" },
  { label: "נרתיקנית - Volvariella", path: "volvariella" },
  { label: "סדנית - Podaix", path: "podaix" },
  { label: "סוככית - Tubaria", path: "tubaria" },
  { label: "סוליינית - Coriolopsis", path: "coriolopsis" },
  { label: "סיבית - Inocybe", path: "inocybe" },
  { label: "סידית - Limacella", path: "limacella" },
  { label: "ספלונית - Sarcoscypha", path: "sarcoscypha" },
  { label: "סרקודון - Sarcodon", path: "sarcodon" },
  { label: "עורית - Scleroderma", path: "scleroderma" },
  { label: "עמודנית - Schizostoma", path: "schizostoma" },
  { label: "עציונית - Xylaria", path: "xylaria" },
  { label: "עציצית - Leucocoprinus", path: "leucocoprinus" },
  { label: "פומית - Tulostoma", path: "tulostoma" },
  { label: "פחוסית - Disciseda", path: "disciseda" },
  { label: "פטרה - Mycena", path: "mycena" },
  { label: "פטרה - Atheniella", path: "atheniella" },
  { label: "פטרה - Hemimycena", path: "hemimycena" },
  { label: "פינית - Phallus", path: "phallus" },
  { label: "פכית - Scutellinia", path: "scutellinia" },
  { label: "פמוטית - Phellorinia", path: "phellorinia" },
  { label: "פנכית - Barlaea", path: "barlaea" },
  { label: "פסיפסית - Pisolithus", path: "pisolithus" },
  { label: "פקועה - Agaricus", path: "agaricus" },
  { label: "פקעית - Rizopogon", path: "rizopogon" },
  { label: "פרגודית - Vascellum", path: "vascellum" },
  { label: "צבעונית - Panaeolus", path: "panaeolus" },
  { label: "ציצנית - Hebeloma", path: "hebeloma" },
  { label: "צמדית - Hymenopellis", path: "hymenopellis" },
  { label: "צמודית - Fuscoporia", path: "fuscoporia" },
  { label: "צנומה - Marasmius-Gymnopus", path: "marasmius" },
  { label: "צנומית - Marasmiellus", path: "marasmiellus" },
  { label: "קופסית - Geopyxis", path: "geopyxis" },
  { label: "קטיפנית - Pluteus", path: "pluteus" },
  { label: "קמרונית - Chroogomphus", path: "chroogomphus" },
  { label: "קמרונית - Gomphidius", path: "gomphidius" },
  { label: "קערורית - Marcelleina", path: "marcelleina" },
  { label: "קערית - Sarcosphaera", path: "sarcosphaera" },
  { label: "קרוחה - Deconica", path: "deconica" },
  { label: "קרישית - Tremella", path: "tremella" },
  { label: "קרנית - Calocera", path: "calocera" },
  { label: "קשוטית - Inonotus", path: "inonotus" },
  { label: "קשיחית - Stereum", path: "stereum" },
  { label: "קשקשנית - Pholiota", path: "pholiota" },
  { label: "קשתנית - Daldinia", path: "daldinia" },
  { label: "רבפומית - Myriostoma", path: "myriostoma" },
  { label: "רסיסית - Dacrymyces", path: "dacrymyces" },
  { label: "שברירית - Psathyrella", path: "psathyrella" },
  { label: "שחומית - Melanogaster", path: "melanogaster" },
  { label: "שחרחרית - Melanoleuca", path: "melanoleuca" },
  { label: "שינונית - Hydnellum", path: "hydnellum" },
  { label: "שיננית - Hydnum", path: "hydnum" },
  { label: "שלהבת - Pyronema", path: "pyronema" },
  { label: "שלחופית - Hydronocybe", path: "hydronocybe" },
  { label: "שסועית - Schizophyllum", path: "schizophyllum" },
  { label: "שעירית - Tricholomella", path: "tricholomella" },
  { label: "שפתנית - Cheilymenia", path: "cheilymenia" },
  { label: "שקועית - Geopora", path: "geopora" },
  { label: "שרועית - Tapinella", path: "tapinella" },
  { label: "שרפית - Laccaria", path: "laccaria" },
  { label: "תמנית - Octospora", path: "octospora" },
];
